'use strict';
var $ = window.$;

let mediaXxs = 320;
let mediaXs = 480;
let mediaSm = 768;
let mediaMd = 1024;
let mediaLg = 1200;
let mediaXl = 1440;
let mediaXxl = 1600;
let mediaXxxl = 1920;

$(document).ready(function () {
  $.fancybox.defaults.touch = false;
  $.fancybox.defaults.toolbar = false;
  $.fancybox.defaults.infobar = false;
  $.fancybox.defaults.arrows = false;
  $.fancybox.defaults.autoFocus = false;

  $('[data-fancybox*="images"], [data-fancybox*="indicator-gallery"]').fancybox(
    {
      toolbar: true,
      buttons: ['close'],
      arrows: true,
    }
  );

  // fix header

  let initialScroll = 0;
  let $headerHeight = $('.header').height();

  $(document).on('scroll resize', function () {
    let $position = $(window).scrollTop();

    if ($position > 200) {
      $('.header').addClass('is-fixed');
      $('.page').css('padding-top', `${$headerHeight}px`);
      if ($position > initialScroll) {
        $('.header').addClass('is-show');
        $('.header').removeClass('is-hide');
      } else {
        $('.header').removeClass('is-show');
        $('.header').addClass('is-hide');
      }
      initialScroll = $position;
    } else {
      $('.header').removeClass('is-fixed');
      $('.header').removeClass('is-show');
      $('.header').removeClass('is-hide');
      $('.page').css('padding-top', `0`);
    }
  });

  // Открытие мобильного меню
  $('.js-open-menu').on('click', function (e) {
    $(this).toggleClass('is-open');
    $('#mobile-menu').toggleClass('is-open');
    $('#header').toggleClass('menu-open');
    $('body').toggleClass('menu-open');
  });

  // закрытие мобильного меню
  $('.js-close-menu').on('click', function (e) {
    $(this).removeClass('is-open');
    $('.js-open-menu').removeClass('is-open');
    $('#mobile-menu').removeClass('is-open');
    $('#header').removeClass('menu-open');
    $('body').removeClass('menu-open');
  });

  $('[drop-search]').on('click', function () {
    const $block = $(this).closest('.header');
    $block.find('[class*="__form"]').toggleClass('is-open');
    $(this).toggleClass('is-open');
    // $block.find('[class*="__form"]').slideToggle(200);
  });

  $(document).on('click', '[open-filter]', function () {
    var $block = $(this).parent();
    var $filter = $block.find('[class*="__form"]');
    $('body > jdiv').hide();
    $('body').addClass('menu-open');
    $filter.addClass('is-open');
  });
  $(document).on('click', '[close-filter]', function () {
    var $form = $(this).closest('[class*="__form"]');
    $('body > jdiv').show();
    $('body').removeClass('menu-open');
    $form.removeClass('is-open');
  });

  $('.open-side-menu').on('click', function () {
    var $parent = $('#side-menu')
      .addClass('is-open')
      .parents('.info-block_exchange');
    $('#side-menu').css('top', $('#header').height() - $parent.offset().top);
  });
  $('.close-side-menu').on('click', function () {
    $('#side-menu').removeClass('is-open');
  });

  const availableTags = [
    'БКС Мир Инвестиций',
    'БКС Мир Инвестиций 2',
    'БКС Мир Инвестиций 3',
    'Юнисервис Капитал',
  ];

  $('[jqueryAutocomplete]').autocomplete({
    source: availableTags,
  });

  // dropdown

  $('[data-drop-prev]').on('click', function () {
    $(this).toggleClass('is-open');
    $(this).siblings().slideToggle(200);
    if ($(this).hasClass('is-open')) {
      $(this).text('Свернуть');
    } else {
      $(this).text('Подробнее');
    }
  });

  $('[data-drop-next]').on('click', function () {
    $(this).toggleClass('is-open');
    $(this).siblings().slideToggle(200);
  });

  $('[data-drop-next-sm]').on('click', function () {
    if ($(window).width() > 767) {
      return false;
    } else {
      $(this).toggleClass('is-open');
      $(this).siblings().slideToggle(200);
    }
  });

  $('[data-drop-next-mobile]').on('click', function () {
    if ($(window).width() > 1279) {
      return false;
    } else {
      $(this).toggleClass('is-open');
      $(this).siblings().slideToggle(200);
    }
  });

  // scrollbar
  // mh_todo BOOMIN-565 после обновления, добавления, переключения видов, где ломается скролл - вызвать $(window).trigger('updateCustomScrollBar');
  function initCustomScrollbar() {
    $('.has-scrollbar-y:not(.mCustomScrollbar)').mCustomScrollbar({
      theme: 'my-theme',
      axis: 'y',
    });

    $('.has-scrollbar-x:not(.mCustomScrollbar)').mCustomScrollbar({
      theme: 'my-theme',
      axis: 'x',
    });

    $('.has-scrollbar-default:not(.mCustomScrollbar)').mCustomScrollbar({
      theme: 'my-theme-default',
      axis: 'x',
      callbacks: {
        onTotalScroll: function () {
          $(this).addClass('scroll-is-end');
        },
        whileScrolling: function () {
          $(this).removeClass('scroll-is-end');
        },
      },
    });
  }

  initCustomScrollbar();
  $(window).on('updateCustomScrollBar', initCustomScrollbar);

  //Collapsed
  function collapsedBlock(element) {
    let umm = $(element).closest('.collapsible_container');
    let um = umm.find('.collapsible_dop__block');
    umm.toggleClass('open');
    if (um.css('max-height') != '0px') {
      um.css('max-height', '0px');
    } else {
      um.css('max-height', um.prop('scrollHeight') + 'px');
    }
  }
  window.collapsedBlock = collapsedBlock;

  // tabs
  $(document).delegate('[js-tabs] [data-button]', 'click', function (e) {
    e.preventDefault();
    let $block = $(this).closest('[js-tabs]');
    let index = $(this).data('button');

    $('[data-button]', $block).parent().removeClass('is-active');
    $('[data-button=' + index + ']', $block)
      .parent()
      .addClass('is-active');
    $('[data-tab]', $block).removeClass('is-active');
    $('[data-tab=' + index + ']', $block).addClass('is-active');

    let $sliders = $('[data-tab=' + index + ']').find('.slick-slider');
    if ($sliders.length) $sliders.slick('setPosition');
  });

  $(document).on('click', '[js-active-toggle]', function () {
    $(this).toggleClass('is-active');
  });

  // comment

  $('.show-comment').on('click', function () {
    $(this).toggleClass('is-shown');
    $('.comment-list').slideToggle(200);

    if ($(this).hasClass('is-shown')) {
      $(this).text('Скрыть комментарии');
    } else {
      $(this).text('Показать комментарии');
    }
  });

  $('[comment-action]').on('click', function (e) {
    let $buttonShow = $(this).find('[class*="__button-show"]');
    let $buttonAdd = $(this).find('[class*="__button-add"]');
    let $other = $(this).find('[class*="__other"]');
    let $add = $(this).find('[class*="__add"]');

    if ($(e.target).is($buttonShow)) {
      $buttonShow.toggleClass('is-shown');
      $other.slideToggle(200);
    }

    if ($buttonShow.hasClass('is-shown')) {
      $buttonShow.text('Скрыть');
    } else {
      $buttonShow.text('Показать');
    }

    if ($(e.target).is($buttonAdd)) {
      $buttonAdd.toggleClass('is-shown');
      $add.slideToggle(200);
    }
  });

  // Свернуть меню

  let nav = priorityNav.init({
    mainNavWrapper: '[js-priority-navigation]',
    navDropdownLabel: 'Еще',
  });

  // mask

  $('[inputmode="numeric"]').mask('+7 (999) 999-99-99', { autoclear: false });

  // input-range

  let sliderHandle = $('#custom-handle');

  $('#slider').slider({
    range: 'min',
    min: 200,
    max: 8000,
    value: 450,
    create: function () {
      sliderHandle.text($(this).slider('value'));
    },
    slide: function (event, ui) {
      sliderHandle.text(ui.value);
    },
  });

  // datepicker
  // function onSelectDatepicker(date, formattedDate, datepicker) {
  //   setTimeout(function () {
  //     datepicker.hide();
  //     datepicker.el.value = date;
  //     datepicker.$el.trigger('change');
  //   }, 10);
  // }

  function setBaseOptionsToDatepicker(datepickerNode, gh) {
    if (typeof datepickerNode !== 'undefined') {
      if (
        datepickerNode.val() !== '' &&
        typeof datepickerNode.val() !== 'undefined'
      ) {
        const [day, month, year] = datepickerNode.val().split('.');
        gh.selectDate(new Date(+year, month - 1, +day));
      }
      // gh.update('onSelect', onSelectDatepicker);
    }
  }

  var dateInputMask = function dateInputMask(elm) {
    elm.maxLength = 10;
    elm.addEventListener('keypress', function (e) {
      if (e.keyCode < 47 || e.keyCode > 57) {
        e.preventDefault();
      }

      var len = elm.value.length;

      // If we're at a particular place, let the user type the slash
      // i.e., 12.12.1212
      if (len !== 1 || len !== 3) {
        if (e.keyCode == 47) {
          e.preventDefault();
        }
      }

      // If they don't add the slash, do it for them...
      if (len === 2) {
        elm.value += '.';
      }

      // If they don't add the slash, do it for them...
      if (len === 5) {
        elm.value += '.';
      }
    });
  };
  window.initDatePickers = function () {
    const firstDatepicker = $('[datepicker]');
    const secondDatepicker = $('[datepicker-right]');
    const isMobile = $(window).width() <= 699;
    const config = {
      autoClose: true,
      buttons: ['today', 'clear'],
      dateFormat: 'dd.MM.yyyy',
      isMobile: isMobile,
    };

    if (!isMobile) {
      config['position'] = function ({ $datepicker, $target, $pointer, done }) {
        let popper = uipopper.createPopper($target, $datepicker, {
          placement: 'bottom',

          modifiers: [
            {
              name: 'flip',
              options: {
                padding: {
                  top: 64,
                },
              },
            },
            {
              name: 'offset',
              options: {
                offset: [0, 20],
              },
            },
            {
              name: 'arrow',
              options: {
                element: $pointer,
              },
            },
          ],
        });

        /*
          Возвращаем функцию, которая вызывается при срабатывании `hide()`,
          она обязательно должна вызвать функцию `done()`
          для завершения процесса скрытия календаря 
        */
        return function completeHide() {
          popper.destroy();
          done();
        };
      };
    }
    firstDatepicker.each(function (index, element) {
      dateInputMask(element);
      let gh = new window.datepicker(element, {
        ...config,
      });
      setBaseOptionsToDatepicker($(element), gh);
    });

    secondDatepicker.each(function (index, element) {
      dateInputMask(element);
      let gh = new window.datepicker(element, {
        ...config,
      });
      setBaseOptionsToDatepicker($(element), gh);
    });
  };

  window.initDatePickers();
  // $(document).on('focus', '[datepicker-right], [datepicker]', function () {
  //   $(this).mask('99.99.9999');
  // });
  // $(document).on(
  //   'input change keyup',
  //   '[datepicker-right], [datepicker]',
  //   function () {
  //     var $block = $(this).closest('.form-field');
  //     if (!$block.length) return;

  //     if ($(this).val().length) {
  //       $block.addClass('is-full');
  //     } else {
  //       $block.removeClass('is-full');
  //     }
  //   }
  // );

  //  Плавный переход к якорю

  $('[js-anchor]').on('click', function (event) {
    let target = $(this).attr('href');
    $('.js-open-menu').removeClass('is-open');
    $('#mobile-menu').removeClass('is-open');
    $('html, body').animate(
      {
        scrollTop: $(target).offset().top - 100,
      },
      800
    );
    return true;
  });

  // Якорная ссылка в начало страницы

  function anchorUp() {
    let $block = $('.anchor-up');

    $(document).on('scroll', function () {
      if ($(window).scrollTop() > 400) {
        $block.addClass('is-shown');
      } else {
        $block.removeClass('is-shown');
      }
    });
  }

  anchorUp();

  // Якорные ссылки на странице компании

  $('[js-anchor-list]').each(function () {
    let $block = $(this);
    let $link = $block.find('[class*="__link"]');

    $(document).on('scroll load', function () {
      let scrollPos = $(document).scrollTop();

      $link.each(function () {
        let $currLink = $(this);
        let refElement = $($currLink.attr('href'));
        if (refElement.length) {
          if (
            refElement.position().top - 50 <= scrollPos &&
            refElement.position().top + refElement.height() > scrollPos
          ) {
            $('.side-anchor__list .side-anchor__link').removeClass('is-active');
            $currLink.parent().addClass('is-active');
          } else {
            $currLink.parent().removeClass('is-active');
          }
        }
      });
    });
  });

  function loadSlider(slider) {
    slider;
  }

  // Календарь инвестора
  $('[event]').each(function () {
    let $block = $(this);
    let $tableRow = $block.find('[class*="__row"]');
    let $btnMore = $block.find('[class*="__more"]');
    let $tableRowHide = [];

    if ($tableRow.length > 5) {
      $tableRow.each(function (i) {
        if (i >= 5) {
          $tableRowHide.push($(this));
          $(this).addClass('hide');
        }
      });
    } else if ($tableRow.length <= 2) {
      $btnMore.remove();
    } else {
      $tableRow.each(function (i) {
        if (i >= 2) {
          $tableRowHide.push($(this));
          $(this).addClass('hide');
        }
      });
    }

    $btnMore.text(`+ ещё ${$tableRowHide.length}`);
    $btnMore.on('click', function () {
      $.each($tableRowHide, function (i) {
        $(this).removeClass('hide');
      });
      $(this).addClass('hide');
    });
  });

  // теги

  $('[data-banner-tags]').each(function () {
    let $block = $(this);
    let $tags = $block.find('[class*="__hashtag"]');
    let $hiddenTags = [];

    $block.append('<a href="#" class="main-banner__link">...</a>');
    let $link = $block.find('.main-banner__link');

    function hideTagsCollect() {
      let $width = $(window).width();
      $hiddenTags = [];

      $tags.each(function (i) {
        if ($width > 1279) {
          if (i >= 6) {
            $hiddenTags.push($(this));
          }
        } else if ($width > 1023) {
          if (i >= 4) {
            $hiddenTags.push($(this));
          }
        } else if ($width > 767) {
          if (i >= 2) {
            $hiddenTags.push($(this));
          }
        } else if (i >= 1) {
          $hiddenTags.push($(this));
        }
      });
    }

    function handleTags() {
      if ($hiddenTags.length) $link.css('display', 'inline-flex');
      else $link.css('display', 'none');

      $tags.each(function () {
        $(this).removeClass('hide');
      });

      for (const i in $hiddenTags) {
        const $tag = $hiddenTags[i];
        $tag.addClass('hide');
      }
    }

    hideTagsCollect();
    handleTags();

    $(window).on('resize', function () {
      hideTagsCollect();
      handleTags();
    });
  });

  $('[data-tags]').each(function () {
    let $block = $(this);
    let $tags = $block.find('[class*="__tag"]');
    let $hiddenTags = [];

    $block.append(
      '<div class="publication-event__tag publication-event__tag_last">Все теги</div>'
    );
    let $lastTag = $block.find('[class*="_last"]');

    $lastTag.addClass('hide');

    let isOpened = false;

    function hideTagsCollect() {
      let $width = $(window).width();
      $hiddenTags = [];

      $tags.each(function (i) {
        if ($width > 1023) {
          if (i >= 17) {
            $hiddenTags.push($(this));
          }
        } else if ($width > 767) {
          if (i >= 12) {
            $hiddenTags.push($(this));
          }
        } else if (i >= 5) {
          $hiddenTags.push($(this));
        }
      });
    }

    function handleTags() {
      if ($hiddenTags.length) $lastTag.css('display', 'inline-flex');
      else $lastTag.css('display', 'none');

      $tags.each(function () {
        $(this).removeClass('hide');
      });

      for (const i in $hiddenTags) {
        const $tag = $hiddenTags[i];
        if (!isOpened) $tag.addClass('hide');
      }
    }

    hideTagsCollect();
    handleTags();
    $block.addClass('_init');

    $(window).on('resize', function () {
      hideTagsCollect();
      if (!isOpened) handleTags();
    });

    $lastTag.on('click', function () {
      isOpened = !isOpened;
      handleTags();
      $(this).text(isOpened ? 'Скрыть теги' : 'Все теги');
    });
  });

  // sliders

  $('[banner-slider]').each(function () {
    let $block = $(this);
    let $init = $block.find('[class*="__list"]');
    let $dots = $block.find('[class*="-dots"]');
    let $prev = $block.find('[class*="_prev"]');
    let $next = $block.find('[class*="_next"]');

    $init.slick({
      infinite: true,
      fade: true,
      sliderToShow: 1,
      slidesToScroll: 1,
      arrows: true,
      dots: true,
      appendDots: $dots,
      prevArrow: $prev,
      nextArrow: $next,
    });
  });

  $('[portfolios-slider]').each(function () {
    let $block = $(this);
    let $init = $block.find('[class*="__list"]');
    let $dots = $block.find('[class*="-dots"]');
    let $prev = $block.find('[class*="_prev"]');
    let $next = $block.find('[class*="_next"]');

    $init.slick({
      infinite: true,
      sliderToShow: 1,
      slidesToScroll: 1,
      mobileFirst: true,
      arrows: true,
      dots: true,
      appendDots: $dots,
      prevArrow: $prev,
      nextArrow: $next,
      responsive: [
        {
          breakpoint: 768 - 1,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 2,
          },
        },
        {
          breakpoint: 1280 - 1,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 3,
          },
        },
      ],
    });
  });

  $('[boomerang-slider]').each(function () {
    let $block = $(this);
    let $init = $block.find('[class*="__list"]');
    let $dots = $block.find('[class*="-dots"]');
    let $prev = $block.find('[class*="_prev"]');
    let $next = $block.find('[class*="_next"]');

    $init.slick({
      infinite: true,
      sliderToShow: 1,
      slidesToScroll: 1,
      mobileFirst: true,
      arrows: true,
      dots: true,
      appendDots: $dots,
      prevArrow: $prev,
      nextArrow: $next,
      responsive: [
        {
          breakpoint: 768 - 1,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 2,
          },
        },
        {
          breakpoint: 1024 - 1,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 3,
          },
        },
      ],
    });
  });

  $('[release-slider]').each(function () {
    let $block = $(this);
    let $init = $block.find('[class*="__list"]');
    let $dots = $block.find('[class*="-dots"]');
    let $prev = $block.find('[class*="_prev"]');
    let $next = $block.find('[class*="_next"]');

    $init.slick({
      infinite: true,
      sliderToShow: 1,
      slidesToScroll: 1,
      mobileFirst: true,
      arrows: true,
      dots: true,
      appendDots: $dots,
      prevArrow: $prev,
      nextArrow: $next,
      responsive: [
        {
          breakpoint: 768 - 1,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1,
          },
        },
      ],
    });
  });

  $('[partner-slider]').each(function () {
    let $block = $(this);
    let $init = $block.find('[class*="__list"]');
    let $dots = $block.find('[class*="-dots"]');
    let $prev = $block.find('[class*="_prev"]');
    let $next = $block.find('[class*="_next"]');

    $init.slick({
      infinite: false,
      sliderToShow: 1,
      slidesToScroll: 1,
      mobileFirst: true,
      arrows: true,
      dots: true,
      appendDots: $dots,
      prevArrow: $prev,
      nextArrow: $next,
      responsive: [
        {
          breakpoint: 768 - 1,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1,
          },
        },
      ],
    });
  });

  let articleSlider = $('[article-slider]').each(function () {
    let $block = $(this);
    let $init = $block.find('[class*="__list"]');
    let $dots = $block.find('[class*="-dots"]');
    let $prev = $block.find('[class*="_prev"]');
    let $next = $block.find('[class*="_next"]');

    $init.slick({
      infinite: true,
      sliderToShow: 1,
      slidesToScroll: 1,
      mobileFirst: true,
      arrows: true,
      dots: true,
      // accessibility: false,
      // adaptiveHeight: true,
      appendDots: $dots,
      prevArrow: $prev,
      nextArrow: $next,
    });
  });

  let articleNavSlider = $('[article-nav-slider]').each(function () {
    let $block = $(this);
    let $init = $block.find('[class*="__list"]');
    let $nav = $block.find('[class*="__nav"]');

    $init.slick({
      sliderToShow: 1,
      slidesToScroll: 1,
      arrows: false,
      asNavFor: $nav,
      infinite: false,
    });

    $nav.slick({
      asNavFor: $init,
      infinite: false,
      dots: false,
      arrows: false,
      variableWidth: true,
      focusOnSelect: true,
    });
  });

  $('[issuer-slider]').each(function () {
    let $block = $(this);
    let $init = $block.find('[class*="__list"]');
    let $dots = $block.find('[class*="-dots"]');
    let $prev = $block.find('[class*="_prev"]');
    let $next = $block.find('[class*="_next"]');

    $init.slick({
      infinite: true,
      sliderToShow: 1,
      slidesToScroll: 1,
      mobileFirst: true,
      arrows: true,
      dots: true,
      appendDots: $dots,
      prevArrow: $prev,
      nextArrow: $next,
      responsive: [
        {
          breakpoint: 480 - 1,
          settings: {
            slidesToShow: 2,
          },
        },
        {
          breakpoint: 768 - 1,
          settings: {
            slidesToShow: 3,
          },
        },
        {
          breakpoint: 1024 - 1,
          settings: {
            slidesToShow: 2,
          },
        },
      ],
    });
  });

  $('[key-slider]').each(function () {
    let $block = $(this);
    let $init = $block.find('[class*="__list"]');
    let $dots = $block.find('[class*="-dots"]');
    let $prev = $block.find('[class*="_prev"]');
    let $next = $block.find('[class*="_next"]');

    $init.slick({
      infinite: true,
      sliderToShow: 1,
      slidesToScroll: 1,
      mobileFirst: true,
      arrows: true,
      dots: true,
      appendDots: $dots,
      prevArrow: $prev,
      nextArrow: $next,
      responsive: [
        {
          breakpoint: 768 - 1,
          settings: {
            slidesToShow: 2,
          },
        },
        {
          breakpoint: 1440 - 1,
          settings: {
            slidesToShow: 3,
          },
        },
      ],
    });
  });

  $(document).bind('DOMSubtreeModified', function () {
    loadSlider(articleNavSlider);
    loadSlider(articleSlider);
  });
  // mh_todo BOOMIN-244
  // Модалки с задержкой
  // setTimeout(() => {
  //   $('#delay-img').fancybox().trigger('click');
  // }, 2000)

  // setTimeout(() => {
  //   $('#delay').fancybox().trigger('click');
  // }, 4000)
  // sticky menu

  $('[input-val]').each(function () {
    let $block = $(this);
    let $input = $block.find('input');
    let $resultList = $block.find('[class*="__result-list"]');

    const checkVisible = (e) => {
      if ($input.val().length > 0) {
        $resultList.addClass('is-active');
      } else {
        $resultList.removeClass('is-active');
      }
    };

    $(document).on('click', (e) => {
      if ($(e.target).parents('[input-val]').length || $(e.target).is($block)) {
        checkVisible();
      } else {
        $resultList.removeClass('is-active');
      }
    });

    $(document).on('input', function () {
      checkVisible();
    });
  });

  // Показ пароля в инпуте
  $(document).on(
    'click',
    '[js-password-input] [class*="__visibility-btn"]',
    function () {
      let $block = $(this).closest('[js-password-input]');
      let $input = $block.find('[class*="__input"]');
      if ($input.attr('type') == 'password') {
        $input.prop('type', 'text');
      } else {
        $input.prop('type', 'password');
      }
    }
  );

  $('[img-input]').each(function () {
    let $input = $(this).find('input');
    let $imgContainer = $(this).find('[class*="__img-container"]');
    let $userImg = $(this).find('[class*="__user-img"]');

    $input.on('change', function () {
      let $files = $input.prop('files');
      if ($files && $files[0]) {
        let reader = new FileReader();
        reader.onload = function (e) {
          $userImg.attr('src', e.target.result);
          $imgContainer.addClass('is-active');
        };
        reader.readAsDataURL($files[0]);
      }
    });
  });

  $('[request-number]').each(function () {
    let $input = $(this).find('input');
    let $button = $(this).find('button');

    $input.on('input', function () {
      if ($input.val().length > 0) {
        $button.addClass('is-active');
      } else {
        $button.removeClass('is-active');
      }
    });
  });

  $('[hide-element]').on('click', function (e) {
    const $btn = $(this).find('[class*="__close"]');

    if ($(e.target).is($btn)) {
      $(this).hide('slow');
    }
  });

  $('[sticky]').each(function () {
    let $block = $(this);
    let $menu = $('[sticky-menu]');
    let $menuHeight = $menu.height();
    let $header = $('.header');

    $(document).on('scroll', function () {
      let $blockHeight = $block.height();
      let $headerHeight = $header.height();
      let $windowWidth = $(window).width();
      if ($windowWidth > mediaMd - 1) {
        let $windowScroll = $(window).scrollTop();
        let $stickyStart = $block.offset().top;
        let $stickyFinish = $windowScroll + $stickyStart + $menuHeight;
        if ($stickyFinish >= $blockHeight + $stickyStart + 100) {
          $menu.addClass('stop');
          $menu.css('top', `${$blockHeight - $menuHeight - 100}px`);
        } else if ($windowScroll > $stickyStart) {
          $menu.removeClass('stop');
          $menu.addClass('is-fixed');
          $menu.css('top', `${$headerHeight}px`);
        } else {
          $menu.removeClass('stop');
          $menu.removeClass('is-fixed');
        }
      }
    });
  });

  $('[slider-dots]').each(function () {
    let transformXIntervalNext = -25;
    let transformXIntervalPrev = 25;
    let maxDots = 5;
    let $block = $(this);
    let $init = $block.find('[class*="__list"]');
    let $list = $block.find('ul.slick-dots');
    let $dots = $list.find('li');

    function setBoundries(slick, state) {
      if (state === 'default') {
        slick.find('ul.slick-dots li').eq(4).addClass('n-sm');
      }
    }

    $list.wrap("<div class='slick-dots-container'></div>");
    $dots.each(function (index) {
      $(this).addClass('dot-index-' + index);
    });
    $list.css('transform', 'translateX(0)');
    setBoundries($block, 'default');

    let transformCount = 0;
    $init.on('beforeChange', function (event, slick, currentSlide, nextSlide) {
      let totalCount = $dots.length;
      if (totalCount > maxDots) {
        if (nextSlide > currentSlide) {
          if (
            $block
              .find('ul.slick-dots li.dot-index-' + nextSlide)
              .hasClass('n-sm')
          ) {
            if (!$block.find('ul.slick-dots li:last-child').hasClass('n-sm')) {
              transformCount = transformCount + transformXIntervalNext;
              $block
                .find('ul.slick-dots li.dot-index-' + nextSlide)
                .removeClass('n-sm');
              let nextSlidePlusOne = nextSlide + 1;
              $block
                .find('ul.slick-dots li.dot-index-' + nextSlidePlusOne)
                .addClass('n-sm');
              $block
                .find('ul.slick-dots')
                .css('transform', 'translateX(' + transformCount + 'px)');
              let pPointer = nextSlide - 3;
              let pPointerMinusOne = pPointer - 1;
              $block
                .find('ul.slick-dots li')
                .eq(pPointerMinusOne)
                .removeClass('p-sm');
              $block.find('ul.slick-dots li').eq(pPointer).addClass('p-sm');
            }
          }
        } else {
          if (
            $block
              .find('ul.slick-dots li.dot-index-' + nextSlide)
              .hasClass('p-sm')
          ) {
            if (!$block.find('ul.slick-dots li:first-child').hasClass('p-sm')) {
              transformCount = transformCount + transformXIntervalPrev;
              $block
                .find('ul.slick-dots li.dot-index-' + nextSlide)
                .removeClass('p-sm');
              let nextSlidePlusOne = nextSlide - 1;
              $block
                .find('ul.slick-dots li.dot-index-' + nextSlidePlusOne)
                .addClass('p-sm');
              $block
                .find('ul.slick-dots')
                .css('transform', 'translateX(' + transformCount + 'px)');
              let nPointer = currentSlide + 3;
              let nPointerMinusOne = nPointer - 1;
              $block.find('ul.slick-dots li').eq(nPointer).removeClass('n-sm');
              $block
                .find('ul.slick-dots li')
                .eq(nPointerMinusOne)
                .addClass('n-sm');
            }
          }
        }
      }
    });
  });

  $('[data-current-link]').each(function () {
    $(this).find('[class*="__link"]').text('...');
  });

  $('.table-trading').each(function () {
    const $table = $(this);
    const countColumns = $table.find('th').length;
    $table.addClass(`table-trading_columns-${countColumns}`);
  });

  function setScreenHWCookie() {
    $.cookie('SCREEN_WIDTH', window.outerWidth, { path: '/' });
    $.cookie('SCREEN_HEIGHT', window.innerHeight, { path: '/' });
    return true;
  }
  $(window).on('resize', setScreenHWCookie);
  setScreenHWCookie();
});

// Filter searched

function inidSearchedCard() {
  $('.searched').each(function () {
    const elems = $(this).find('.searched__items .searched__item');
    const full = $(this).find('.searched__item');
    $(this)
      .find('.restore-button')
      .on('click', function (e) {
        e.preventDefault();
        full.each(function (e) {
          $(this).find('input[type=checkbox]').prop('checked', false);
        });
        $('[data-companies-param-filter-form]').submit();
      });

    $(this)
      .find('.search')
      .on('input', function () {
        const searchedValue = this.value.toLowerCase();
        elems.each(function () {
          if (
            !$(this)
              .data('searched-item-value')
              .toLowerCase()
              .includes(searchedValue)
          ) {
            $(this).hide();
          } else {
            $(this).show();
          }
        });
      });
  });
}
$(window).on('updateSearchedCard', inidSearchedCard);

$.fn.datepicker = function (df) {
  const elem = this[0];
  let config = {
    ...df,
    onSelect: ({ date, formattedDate, datepicker }) => {
      df.onSelect(formattedDate);
    },
  };
  return { data: () => new window.datepicker(elem, config) };
};
